// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_FXW","cls2":"common-cls2_JPo common-cls1_FXW"};